import { Menu, type MenuProps } from '@affine/component';
import type { RefObject } from 'react';

import { STREAMLAIN_DROPDOWN_MENU_OFFSET } from './chrome';
import { RadixDropdownPanelChrome } from './radix-chrome';

export type StreamLainMenuProps = MenuProps & {
  triggerRef: RefObject<HTMLElement | null>;
};

/** Dropdown menu with the shared StreamLain disclosure chrome. */
export function StreamLainMenu({
  contentOptions,
  items,
  triggerRef,
  ...props
}: StreamLainMenuProps) {
  return (
    <Menu
      {...props}
      contentOptions={{
        collisionPadding: 8,
        sideOffset: STREAMLAIN_DROPDOWN_MENU_OFFSET,
        ...contentOptions,
      }}
      items={
        <RadixDropdownPanelChrome triggerRef={triggerRef}>
          {items}
        </RadixDropdownPanelChrome>
      }
    />
  );
}
